import React from 'react';
import Popup from '../../Popup';
import config from '../../../../config';

const DeleteEventFailedPopup = ({ close, unpublishEvent, dualMatchEvent }) => {
    const handleUnpublishEvent = (e) => {
        e.preventDefault();
        unpublishEvent();
    };

    return (
        <Popup
            className="popup-sm"
            onCloseClick={close}
            data-testid="modal.delete-event-failed"
            config={{
                fullScreen: false,
                noPadding: true,
                scrollable: false,
                /* style: {
                        //height: '370px',
                        //width: '600px'
                    } */
            }}
        >
            <div className="popup-section p24 pt0">
                <h5 data-testid="modal.delete-event-failed.heading">Cannot delete event</h5>
            </div>
            <div className="popup-section p24 pt0">
                {dualMatchEvent && (
                    <p data-testid="modal.delete-event-failed.description">Events with Results Posted cannot be deleted.
                        Please contact <a href={`https://support.${config.siteBaseUrl}/support/tickets/new`} rel="noopener noreferrer" target="_blank" data-testid="modal.delete-event-failed.support-link"> Support Team </a> for additional assistance.
                    </p>
                )}
                {!dualMatchEvent && (
                    <p data-testid="modal.delete-event-failed.description">Events with player registrations cannot be deleted.
                        You can <a onClick={handleUnpublishEvent} data-testid="modal.delete-event-failed.unpublish-link">unpublish</a> the event so it doesn&apos;t show for any players.
                        Please contact <a href={`https://support.${config.siteBaseUrl}/support/tickets/new`} rel="noopener noreferrer" target="_blank" data-testid="modal.delete-event-failed.support-link"> Support Team </a> for additional assistance.
                    </p>
                )}
                <div className="mt24">
                    <div className="row">
                        <div className="col-12">
                            <div className="div mb24" />
                            <button
                                type="button"
                                className="btn btn-default btn-default text-uppercase btn-block"
                                onClick={close}
                                data-testid="modal.delete-event-failed.got-it-btn"
                            >Got It
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Popup>
    );
};

export default DeleteEventFailedPopup;
